import { err, ok, Result } from "neverthrow"
import { ArrayToken, ScalarToken, Token, TokenPattern, TokenPatterns, TokenType } from "./Token"
import type { CalcScriptCompileError } from "./CompilerTypes"

export class CalcScriptLexer {
	private findTokenMatch(input: string): TokenPattern | null {
		const patternResult = TokenPatterns.find(x => input.match(x.pattern) !== null)

		if(patternResult) {
			return patternResult
		}

		return null;
	}

	private buildScalarToken(type: ScalarToken['type'], value: string, line: number, column: number): ScalarToken {
		return { type, value, line, column }
	}

	private buildArrayToken(value: Token[], line: number, column: number): ArrayToken {
		return {
			type: TokenType.ARRAY,
			value,
			line,
			column
		}
	}

	public tokenize(input: string): Result<Token[], CalcScriptCompileError> {
		let tokens: Token[] = []
		let line = 1
		let column = 1

		while (input.length > 0) {
			let patternResult = this.findTokenMatch(input)

			if (!patternResult) {
				return err({
					area: 'CalcScriptLexer',
					message: `Unknown token '${input[0]}'`,
					line,
					column,
				})
			}

			const {type, pattern} = patternResult
			const tokenMatch = input.match(pattern)

			if (tokenMatch) {
				const value = tokenMatch[0]

				if(type === TokenType.ARRAY) {
					const innerContent = value.slice(1, -1)
					const innerResult = this.tokenize(innerContent)

					if (innerResult.isErr()) {
						return err(innerResult.error)
					}
					
					const arrTokens = innerResult.value.filter(t =>
						t.type !== TokenType.PUNCTUATION && t.type !== TokenType.LINEBREAK
					)
					tokens.push(this.buildArrayToken(arrTokens, line, column))
				}
				else if (type !== TokenType.WHITESPACE && type !== TokenType.COMMENT) {
					tokens.push(this.buildScalarToken(type, value, line, column))
				}

				const newLines = value.match(/\n/g)
				if (newLines) {
					line += newLines.length
					column = 1
				} else {
					column += value.length
				}

				input = input.slice(tokenMatch[0].length)
			}
		}

		return ok(tokens)
	}
}
